define('shoptheme/components/ui/affix-generic',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-affix"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({

		blocks: null,

		$init: function() {
			var self = this;
			this.blocks = $('[data-affix-target]');
			this.blocks.each(function() {
				var block = $(this);
				self._init(block);
				$(window).on('cookieconsent.open cookieconsent.close', function(){
					$(window).off('.affix');
					block.removeData('bs.affix').removeClass('affix affix-top affix-bottom');
					self._init(block);
				});
			});
		},

		_init: function(block){
			var heightElement = $(block.data('affix-height-element')),
					top = block.offset().top,
					bottom = (heightElement.length) ? $(document).height() - heightElement.offset().top - heightElement.outerHeight(true) : 0;

				block.width(block.parent().width());

				block.css('position','relative');

				block.affix({
					offset: {
						top: top,
						bottom: bottom
					}
				});

				$(window).resize($.throttle(10, function() {block.width(block.parent().width());}));
		}
	});

});

